<template>
    <v-app>
        <main-nav-drawer />
        <v-app-bar dense app style="height: var(--vuetify-application-top)" class="kp-toolbar-bg">
            <v-spacer></v-spacer>

            <v-btn v-if="showSupport" icon small>
                <KpIcon icon-cls="ic-20 ic-support ic-col-grey" />
            </v-btn>

            <v-menu offset-y>
                <template #activator="{ on, attrs }">
                    <v-btn text elevation="0" v-bind="attrs" class="user-menu-btn" v-on="on">
                        <span>{{ user.firstname }} {{ user.lastname }}</span>
                        <v-avatar class="ma-1" color="primary white--text" size="24"
                            >{{ user.firstname?.length ? user.firstname[0] : '?' }}
                        </v-avatar>
                        <KpIcon icon-cls="ic-20 ic-arrowdown ic-col-grey" />
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="logout">
                        <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item link :to="{ name: 'user-profile' }">
                        <v-list-item-title>{{ $t('user_profile') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        v-if="userInfo().event_organizer_id"
                        link
                        :to="{ name: 'address-edit', params: { id: userInfo().event_organizer?.address_id || -1 } }"
                    >
                        <v-list-item-title>{{ $t('my_stammdaten') }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main class="kp-root-panel-bg">
            <div class="ml-5 mr-2 mb-5">
                <router-view />
            </div>
        </v-main>
        <Toast></Toast>
        <KpFooter />
    </v-app>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';
import MinasaImg from '@/assets/minasa_logo.svg';
import MainNavDrawer from '@/components/MainNavDrawer.vue';
import Toast from '@/components/Toast.vue';
import { userInfo, globalParam } from '@/helpers/globals';
import KpFooter from '@/components/KpFooter.vue';

export default Vue.extend({
    name: 'AuthRootView',
    components: {
        MainNavDrawer,
        Toast,
        KpFooter,
    },
    data: () => ({
        drawer: true,
        mini: true,
        MinasaImg,
        showSupport: globalParam('dashboard.supportBtn.show'),
    }),
    computed: {
        ...mapState({
            // TODO: type any: I did not figure out the correct type for the state yet...
            user: (state: any) => state.user.record,
        }),
    },
    methods: {
        ...mapActions('user', ['logout']),
        userInfo,
    },
});
</script>

<style lang="scss" scoped>
.user-menu-btn {
    color: var(--gray-text-color);
}
</style>
